type ShouldApplyEmptyTabFillArgs = {
  key: string;
  emptyTabFillValue?: string | null;
  currentValueLength: number;
  slashSuggestionActive?: boolean;
  atMentionSuggestionActive?: boolean;
};

export const shouldApplyEmptyTabFill = ({
  key,
  emptyTabFillValue,
  currentValueLength,
  slashSuggestionActive = false,
  atMentionSuggestionActive = false
}: ShouldApplyEmptyTabFillArgs): boolean =>
  key === 'Tab' &&
  Boolean(emptyTabFillValue) &&
  currentValueLength === 0 &&
  !slashSuggestionActive &&
  !atMentionSuggestionActive;

export const getEmptyTabFillText = (
  emptyTabFillValue: string | null | undefined,
  characterLimit: number
): string => (emptyTabFillValue || '').substring(0, characterLimit);
